import { LoaderCircle } from "lucide-react"

export const LoadingPage: React.FC = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoaderCircle className="animate-spin" />
    </div>
  )
}
